import React, { useEffect, useState } from 'react';
import './NetflixTitle.css';
import netflixSound from './netflix-sound.mp3';
import { useNavigate } from 'react-router-dom';
import logoImage from './images/Dev-Ambani-logo.png';

const NetflixTitle = () => {
  const [started, setStarted] = useState(false);
  const navigate = useNavigate();

  const handleStart = () => {
    if (started) return;
    setStarted(true);
    const audio = new Audio(netflixSound);
    audio.play().catch(() => {});
  };

  useEffect(() => {
    if (started) {
      const timer = setTimeout(() => {
        navigate('/browse');
      }, 4000);
      return () => clearTimeout(timer);
    }
  }, [started, navigate]);

  return (
    <div className="netflix-container" onClick={handleStart}>
      {!started ? (
        <div className="netflix-prompt">
          <img
            src={logoImage}
            alt="Dev Ambani"
            className="netflix-logo-static"
          />
          <span className="netflix-play-hint">Click anywhere to start</span>
        </div>
      ) : (
        <img
          src={logoImage}
          alt="Dev Ambani"
          className="netflix-logo animate"
        />
      )}
    </div>
  );
};

export default NetflixTitle;
